<div class="bs-dialog">
    <div class="bs-dialog-title">
        <span i18n>Warning: Device quota reached!</span>
        <a class="bs-dialog-close" (click)="close()"><i class="fa fa-close"></i></a>
    </div>
    <div class="bs-dialog-content">
        <div class="text-center padding-top-large padding-bottom-large">
            @if (user?.admin) {
            <span i18n
                >You've reached the monthly active device allowance on your current subscription
                plan. Please upgrade your subscription.</span
            >
            } @if (!user?.admin) {
            <span i18n
                >You've reached the monthly active device allowance on your current subscription
                plan. Please ask your administrator to upgrade your subscription.</span
            >
            }
        </div>
    </div>
    <div class="bs-dialog-actions">
        <span class="flexbox-flex"></span>
        @if (user?.admin) {
        <button class="bs-button bs-primary" type="button" (click)="upgrade()" i18n>Upgrade</button>
        } @if (!user?.admin) {
        <button class="bs-button bs-primary" type="button" (click)="notify()" i18n>
            Notify admin
        </button>
        }
        <span class="flexbox-flex"></span>
    </div>
</div>
